export const HARM_SCALE_POINTS = [
    0.0, 0.1, 0.2, 0.5, 1.0, 2.2, 4.6, 10.0, 21.5, 31.6, 46.4,
];

export const LIKELIHOOD_SCALE_POINTS = [
    5600, 3200, 1800, 1000, 560, 320, 180, 100, 56, 32, 18, 10, 6, 3, 2, 1,
];

export const LIKELIHOOD_SCALE_DESCRIPTIONS = [
    'Average',
    'Very Unlikely',
    'Unlikely',
    'Likely',
    'Very Likely',
    'Almost Certain',
];

export const CERTAIN_LIKELIHOOD_RATING = 1;
export const CERTAIN_LIKELIHOOD_DESCRIPTION = 'Certain';

export const LESS_THAN_AVERAGE = 'Less Than Average';

export const SPREAD_OF_HARM_TOTAL = 100;

export const CLASSI_WEIGHTING = 10000;
export const CLASSII_WEIGHTING = 1000;
export const CLASSIII_WEIGHTING = 300;
export const CLASSIV_WEIGHTING = 10;

export const HARM_CLASSES = [
    {
        name: 'Class I',
        fieldName: 'classi_rating',
    },
    {
        name: 'Class II',
        fieldName: 'classii_rating',
    },
    {
        name: 'Class III',
        fieldName: 'classiii_rating',
    },
    {
        name: 'Class IV',
        fieldName: 'classiv_rating',
    },
];

export const RADON_LEVELS = [25, 50, 100, 150, 200, 400, 800];
